// extracted by mini-css-extract-plugin
module.exports = {"infoTextWrapper":"officialQuestionnaireFormModal_infoTextWrapper__YKzft","helpInfoText":"officialQuestionnaireFormModal_helpInfoText__muDwA"};